import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { getToken } from "../../utils/contractHelpers";
import { gemsRouterContract } from "../../utils/Enviroment";


export const CreateToken = () => {
    const web3 = useWeb3();
    const stakingAddress = gemsRouterContract;
    const contract = getToken(stakingAddress, web3);
    const { account } = useWeb3React()
    const CreateTokenHook = useCallback(
        async (projectName, ticker, futureTimestamp, firstButAmount, signature) => {
            const BuyAmountInWei = web3.utils.toWei(firstButAmount, "ether");
            let gasPrice = await web3.eth.getGasPrice();
            gasPrice = parseInt(gasPrice);
            try {
                const launch = await contract?.methods?.launch(projectName, ticker, futureTimestamp, signature)?.send({ from: account, gasPrice: gasPrice, value: BuyAmountInWei });
                return launch;
            } catch (e) {
                throw e;
            }
        },
        [contract, web3, account]
    );
    return { CreateTokenHook: CreateTokenHook };
};

export default CreateToken;










